/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { ISocialShareConfig, ISocialShareProps, orientation } from './social-share.props.autogenerated';

export interface ISocialShareViewProps extends ISocialShareProps<ISocialShareConfig> {
    isConsentGiven: boolean;
    SocialShareItemElements: React.ReactNode[];
    SocialShare: IModuleProps;
    SocialShareList: INodeProps;
    SocialShareItem: INodeProps;
    SocialShareItemCustomization: INodeProps;
}

/**
 *
 * SocialShare component
 * @extends {React.PureComponent<ISocialShareProps<ISocialShareConfig>>}
 */
class SocialShare extends React.PureComponent<ISocialShareProps<ISocialShareConfig>> {
    constructor(props: ISocialShareProps<ISocialShareConfig>) {
        super(props);
    }

    public render(): JSX.Element | null {
        const { slots } = this.props;

        if (slots && slots.socialShareItems.length === 0) {
            this.props.context.telemetry.error('No social media is enable for sharing, module wont render');
            return null;
        }

        const isConsentGiven =
        this.props.context.request &&
        this.props.context.request.cookies &&
        this.props.context.request.cookies.isConsentGiven &&
        this.props.context.request.cookies.isConsentGiven();

        if (isConsentGiven === false) {
            return null;
        }

        const viewprops = {
            ...this.props,
            SocialShare: {
                moduleProps: this.props,
                className: classnames('ms-social-share', this.props.config.className)
            },
            SocialShareList: {
                'data-title': this.props.config.caption,
                className: `ms-social-share-ul ${this.props.config.caption && 'caption'} ${this.props.config.orientation === orientation.vertical ? 'vertical' : ''}`,
                tag: 'ul'
            },
            SocialShareItem: {
                className: 'ms-social-share-li',
                tag: 'li',
                tabIndex: '0'
            },
            SocialShareItemElements: slots && slots.socialShareItems.length > 0 && slots.socialShareItems
        };

        return this.props.renderView(viewprops) as React.ReactElement;
    }
}

export default SocialShare;
